export type DfIconSize = 'large' | 'medium' | 'small' | 'extra-small';
export const DfIconSize = undefined; // typescript has some issues: https://stackoverflow.com/questions/52258061/export-not-found-on-module

export enum DfIconMap {
  large = 24,
  medium = 16,
  small = 12,
  'extra-small' = 8,
}
